export default "__VITE_ASSET__CRnBKqb6__"